import { PageNode } from "../../types/PageNode";
import { OnClickActionType } from "../../types/OnClickAction";

const isTruthyAdultLinkFlag = (value: unknown): boolean =>
    value === true || value === "true" || value === 1;

export const isAdultOpenLink = (node: PageNode): boolean => {
    const onClickAction = node.onClickAction;
    if (!onClickAction?.value) {
        return false;
    }

    return (
        Number(onClickAction.type) === OnClickActionType.OpenLink &&
        isTruthyAdultLinkFlag(onClickAction.isAdultLink)
    );
};

export const treeHasAdultLinks = (nodes: PageNode[]): boolean =>
    nodes.some((node) => {
        if (isAdultOpenLink(node)) {
            return true;
        }

        return node.nodes?.length ? treeHasAdultLinks(node.nodes) : false;
    });
